// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-a5908516] i.v-icon.mdi.mdi-chevron-down{color:var(--v-orange-btn-base)}.search-form-admp-news__inputs-wrapper div[data-v-a5908516]{max-width:250px;margin-right:20px;margin-bottom:15px}[data-v-a5908516] .v-list-item{text-align:left}[data-v-a5908516] .theme--light.v-list-item--active{background-color:rgba(238,165,7,.2)}", ""]);
// Exports
module.exports = exports;
